import { styled } from '@/core/ui/muiReexports';
/**
 * To be used inside {@link Tooltip} component that is located inside TextField.
 */
export const TextFieldInfoIconContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    padding: theme.spacing(2),
    cursor: 'default',
}));
